import PropTypes from 'prop-types';
import React from 'react';
import { CSSTransition } from 'react-transition-group';

import { mediumUp } from 'constants/mediaQueries';
import Theme from 'styles/theme';

import DrawerConstants from './constants';

const DRAWER_OPEN_TRANSFORM = 'transform: translateX(0%)';
const DRAWER_CLOSE_TRANSFORM = 'transform: translateX(100%)';

const DrawerContent = ({ visible, children, transitionDuration }) => (
  <CSSTransition
    in={visible}
    timeout={{
      enter: transitionDuration,
      exit: transitionDuration,
    }}
    unmountOnExit
    classNames={{
      enter: 'Drawer__content--enter',
      enterActive: 'Drawer__content--active-enter',
      enterDone: 'Drawer__content--done-enter',
      exit: 'Drawer__content--exit',
      exitActive: 'Drawer__content--active-exit',
      exitDone: 'Drawer__content--done-exit',
    }}
  >
    <div className="Drawer__content">
      {children}
      <style jsx>
        {`
          .Drawer__content {
            position: fixed;
            z-index: ${Theme.get('z-index-drawer')};
            right: 0;
            top: 0;
            height: 100%;
            width: 100%;
            background-color: ${Theme.get('colors-white')};
            transition: transform ${Theme.get('transition-duration-ms')}
              ${Theme.get('transition-timing-ease-out')};
          }

          @media ${mediumUp} {
            .Drawer__content {
              width: ${DrawerConstants.DRAWER_WIDTH}px;
              overflow-y: visible;
              overflow-x: hidden;
            }
          }

          .Drawer__content--enter {
            ${DRAWER_CLOSE_TRANSFORM};
          }
          .Drawer__content--active-enter {
            ${DRAWER_OPEN_TRANSFORM};
          }

          .Drawer__content--done-enter {
            ${DRAWER_OPEN_TRANSFORM};
          }

          .Drawer__content--exit {
            ${DRAWER_OPEN_TRANSFORM};
          }
          .Drawer__content--active-exit {
            ${DRAWER_CLOSE_TRANSFORM};
          }
        `}
      </style>

      <style jsx global>
        {`
          .Drawer__content--enter .Drawer__panel,
          .Drawer__content--active-enter .Drawer__panel,
          .Drawer__content--done-enter .Drawer__panel,
          .Drawer__content--exit .Drawer__panel,
          .Drawer__content--active-exit .Drawer__panel,
          .Drawer__content--done-exit .Drawer__panel {
            transition: none;
          }
        `}
      </style>
    </div>
  </CSSTransition>
);

DrawerContent.propTypes = {
  visible: PropTypes.bool.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  transitionDuration: PropTypes.number,
};

DrawerContent.defaultProps = {
  transitionDuration: Theme.get('transition-duration'),
};

export default DrawerContent;
